import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';

@Component({
  selector: 'week-dropdown',
  templateUrl: './week-dropdown.component.html',
  styleUrls: ['./week-dropdown.component.scss'],
  standalone: false,
})
export class WeekDropdownComponent {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  @Input() week: number;
  @Output() weekChange: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  /** A parent fieldset disables the native control; mat-select does not inherit that. */
  get disabledByFieldset(): boolean {
    const fieldset = this.elementRef.nativeElement.closest('fieldset');

    return fieldset instanceof HTMLFieldSetElement && fieldset.disabled;
  }

  emitValue() {
    this.weekChange.emit(this.week);
  }
}
